import { create } from 'zustand';

export interface BettieSettingInfo {
  memberPersonaId: string;
  userNickname: string;
  bettieNickname: string;
  dataUrl: string | null;
  originalDataUrl: string | null;
  isRecommendProfileImage: boolean;
}

const INITIAL_BETTIE_SETTING_INFO: BettieSettingInfo = {
  memberPersonaId: '',
  userNickname: '',
  bettieNickname: '',
  dataUrl: null,
  originalDataUrl: null,
  isRecommendProfileImage: true
};

interface BettieSettingStore {
  bettieSettingInfo: BettieSettingInfo;
  updateBettieSettingInfo: (partial: Partial<BettieSettingInfo>) => void;
  resetBettieSettingInfo: () => void;
}

const useBettieSettingStore = create<BettieSettingStore>((set) => ({
  bettieSettingInfo: INITIAL_BETTIE_SETTING_INFO,
  updateBettieSettingInfo: (partial) =>
    set((state) => ({ bettieSettingInfo: { ...state.bettieSettingInfo, ...partial } })),
  resetBettieSettingInfo: () => set({ bettieSettingInfo: INITIAL_BETTIE_SETTING_INFO })
}));

export const useBettieSettingInfo = () => {
  const bettieSettingInfo = useBettieSettingStore((s) => s.bettieSettingInfo);
  const updateBettieSettingInfo = useBettieSettingStore((s) => s.updateBettieSettingInfo);
  const resetBettieSettingInfo = useBettieSettingStore((s) => s.resetBettieSettingInfo);
  return { bettieSettingInfo, updateBettieSettingInfo, resetBettieSettingInfo };
};
